<template>
    <!-- Карточка журнала -->
    <div :class="`view_card_${ item.uid } view_card px-4 py-4 list-item-component`">
        <div class="vx-row mb-2 lg:mb-4">
            <div class="vx-col w-full flex sm:items-center sm:flex-row flex-col">
                <div class="lg:flex w-full lg:justify-between lg:items-center">
                    <div class="user_detail flex items-center">
                        <div class="user_name lg:flex items-center">
                            <h4 class="todo-title mb-1">{{item.discipline}}</h4>

                            <vs-chip class="ml-0 lg:ml-2"  color="success" v-if="item.load_type">
                                {{item.load_type[0].name}}
                            </vs-chip>
                            <vs-chip class="ml-2 text-sm"  color="warning" v-if="item.study_year">
                                {{item.study_year}}
                            </vs-chip>
                            <vs-chip class="ml-2 text-sm"  color="danger" v-if="item.language">
                                {{item.language.name}}
                            </vs-chip>
                            <vs-chip v-if="item.group_code != 99" class="ml-2 text-sm" color="primary">
                                {{item.group_code}} {{ $t('subgroup') }}
                            </vs-chip>
                            <vs-chip v-if="item.closed == true" class="ml-2 text-sm"  color="danger">
                                {{ $t('closed3') }}
                            </vs-chip>
                            <vs-chip v-else class="ml-2 text-sm"  color="success">
                                {{ $t('open3') }}
                            </vs-chip>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="lg:flex items-center mb-2">
                    <div class="label font-medium mb-1 lg:mr-2 lg:mb-0">{{$t('group')}}:</div>
                    <div class="val" v-if="item.group_code == 99&&item.groups.length>0">
                        {{item.groups[0].name}}
                    </div>
                    <div class="val" v-if="item.group_code != 99&&item.groups.length>0">
                        {{item.groups[0].name}} ({{item.group_code}} {{ $t('subgroup') }})
                    </div>
                </div>
                <div class="lg:flex items-center">
                    <div class="label font-medium mb-1 lg:mr-2 lg:mb-0">{{$t('acad_periods')}}:</div>
                    <div class="val">{{item.acad_periods[0].name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.view_card{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
